import React from 'react';
import { useSelector } from 'react-redux';

import type { WidgetFC } from '@swf/core/types/Widget';
import { CategoryArticleSkeleton, HelpContainer, SearchList } from '@swf/help';

import { helpCenterSearchWidgetModel, useHelpCenterSearchWidget } from './model';

const HelpCenterSearchWidget: WidgetFC = () => {
  const { widgetSelect } = useHelpCenterSearchWidget();
  const categories = useSelector(widgetSelect.categories);
  const searchList = useSelector(widgetSelect.searchList);
  const pageSize = useSelector(widgetSelect.pageSize);

  const isLoading = useSelector(widgetSelect.isLoading);
  const hasPreloaded = useSelector(widgetSelect.hasPreloaded);

  return (
    <HelpContainer
      isLoading={isLoading}
      isPreloaded={hasPreloaded}
      preloader={<CategoryArticleSkeleton />}
    >
      <SearchList categories={categories} searchList={searchList} pageSize={pageSize} />
    </HelpContainer>
  );
};

HelpCenterSearchWidget.model = helpCenterSearchWidgetModel;

export default HelpCenterSearchWidget;
